import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Confetti, X } from "@phosphor-icons/react";
import client from "../lib/api";

export const FirstAdLeadBanner = () => {
  const [lead, setLead] = useState(null);
  const [totalFb, setTotalFb] = useState(0);

  useEffect(() => {
    client.get("/admin/first-ad-lead").then((r) => {
      const l = r.data?.lead;
      if (l && !localStorage.getItem(`fp_first_ad_lead_seen_${l.id}`)) {
        setLead(l);
        setTotalFb(r.data.total_fb_leads || 1);
      }
    }).catch(() => {});
  }, []);

  if (!lead) return null;
  const dismiss = () => {
    localStorage.setItem(`fp_first_ad_lead_seen_${lead.id}`, "1");
    setLead(null);
  };

  return (
    <div
      data-testid="first-ad-lead-banner"
      className="mx-4 sm:mx-8 mt-4 flex items-center gap-3 rounded-lg border border-emerald-500/40 bg-emerald-500/10 px-4 py-3"
    >
      <Confetti size={20} weight="fill" color="#34d399" className="shrink-0" />
      <div className="min-w-0 flex-1">
        <div className="text-xs font-bold tracking-wide text-emerald-300">
          YOUR FIRST FACEBOOK AD LEAD LANDED
        </div>
        <div className="text-xs text-emerald-100/80 mt-0.5">
          <b>{lead.company_name || lead.contact_name || "A trucker"}</b> came in from your paid campaign
          on {String(lead.created_at).slice(0, 10)}
          {totalFb > 1 && ` — ${totalFb} ad leads and counting`}. The funnel works.
        </div>
      </div>
      <Link
        to="/app/inbox"
        data-testid="first-ad-lead-open-inbox"
        className="shrink-0 rounded-full border border-emerald-500/50 px-3 py-1.5 text-[11px] font-semibold text-emerald-300 hover:bg-emerald-500/15 transition-colors"
      >
        Open Inbox
      </Link>
      <button
        data-testid="first-ad-lead-dismiss"
        onClick={dismiss}
        className="shrink-0 text-emerald-400/60 hover:text-emerald-300"
        aria-label="Dismiss"
      >
        <X size={16} weight="bold" />
      </button>
    </div>
  );
};
